import React, { useState } from "react"

import { Link } from "gatsby"
import doenerCase from "scripts/doenerCase"

const all_states = {
  BW: "Baden-Württemberg",
  BY: "Bayern",
  MV: "Mecklenburg-Vorpommern",
  SH: "Schleswig-Holstein",
  NI: "Niedersachsen",
  NW: "Nordrhein-Westphalen",
  RP: "Rheinland-Pfalz",
  HE: "Hessen",
  SL: "Saarland",
  BB: "Brandenburg",
  ST: "Sachsen-Anhalt",
  SN: "Sachsen",
  TH: "Thüringen",
  BE: "Berlin",
  HB: "Bremen",
  HH: "Hamburg",
}

export const PlacesOfDeliveryList = ({
  is_internal_search,
  places_of_delivery_struct,
  initial_list_length = 3,
  text_color,
  location,
}) => {
  const [show_more_places, set_show_more_places] = useState(false)
  const toggle_more_places = () => set_show_more_places(true)

  const page_slug = location?.pathname?.split("/").pop()
  const city_lp_exceptions = ["Berlin", "Bremen", "Hamburg"]

  const create_pod_list_entry = (pod, key_string, index) => {
    const { City, PostalCode, State, Province, city_lp_data } = pod

    const { city_lp_state, city_lp_name } = city_lp_data || {
      city_lp_state: State || all_states[Province],
      city_lp_name: City,
    }

    const is_citystate = city_lp_exceptions.includes(city_lp_name)

    const lp_links = {
      city: !is_citystate
        ? `/ausschreibungsdienste/ausschreibungen/region/${doenerCase(
            city_lp_state
          )}/${doenerCase(city_lp_name)}`
        : `/ausschreibungsdienste/ausschreibungen/region/${doenerCase(
            city_lp_state
          )}`,
      state: `/ausschreibungsdienste/ausschreibungen/region/${doenerCase(
        State || all_states[Province]
      )}`,
    }
    return (
      <p key={`pod-${key_string}-${index}`}>
        {!!city_lp_data && doenerCase(city_lp_name) !== page_slug ? (
          <Link to={lp_links.city} className="link is-semi-shy">
            {PostalCode.length >= 5 ? PostalCode : "Region"} {City}
          </Link>
        ) : (
          <React.Fragment>
            {PostalCode.length >= 5 ? PostalCode : "Region"} {City}
          </React.Fragment>
        )}
        {!is_citystate ||
        doenerCase(city_lp_name) !== doenerCase(city_lp_state) ? (
          <React.Fragment>
            ,{" "}
            {doenerCase(city_lp_state) !== page_slug ? (
              <Link
                to={lp_links.state}
                className={`link is-semi-shy${
                  is_internal_search ? " has-text-white" : ""
                }`}
              >
                {State}
              </Link>
            ) : (
              State
            )}
          </React.Fragment>
        ) : null}
      </p>
    )
  }

  return (
    <React.Fragment>
      <div className={`mb-0 ${!!text_color ? `has-text-${text_color}` : ""}`}>
        {places_of_delivery_struct
          ?.slice(0, initial_list_length)
          ?.map((pod, index) => create_pod_list_entry(pod, "first", index))}
      </div>
      {!!places_of_delivery_struct?.slice(initial_list_length).length ? (
        <React.Fragment>
          <div
            className={`help has-text-mitternachtsblau px-3 has-text-weight-bold is-clickable mt-1 has-background-mitternachtsblau-30 ${
              show_more_places ? "is-hidden" : ""
            }`}
            style={{
              borderRadius: "15px",
              width: "fit-content",
            }}
            onClick={toggle_more_places}
            role={"button"}
            tabIndex="-1"
            onKeyDown={() => {}}
            aria-label={"More Places"}
          >
            + {places_of_delivery_struct?.slice(initial_list_length).length}{" "}
            weitere Anzeigen
          </div>

          <div
            className={`mb-5 ${!!text_color ? `has-text-${text_color}` : ""}`}
            style={{
              transition: "all .3s ease",
              maxHeight: show_more_places ? "1100px" : 0,
              overflowY: show_more_places ? "" : "hidden",
            }}
          >
            {places_of_delivery_struct
              ?.slice(initial_list_length)
              ?.map((pod, index) =>
                create_pod_list_entry(pod, "second", index)
              )}
          </div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  )
}
